import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserData } from '../../hooks/useUserData';
import { db, auth } from '../../firebase/config';
import { doc, updateDoc, deleteDoc } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { Trash2, Plus } from 'lucide-react';

// Import common components that are NOT being made responsive
import { PageTitle } from '../common/common.styles';
import { Button } from '../common/Form.styles';
import { ActionButton } from '../common/common.styles'; // Assuming ActionButton is also common

// Import our NEW responsive components and RoleSelect from the local styles file
import {
  RoleSelect,
  DocumentTable,
  TableHead,
  TableRow,
  TableCell
} from './ManageUsersPage.styles';


const ManageUsersPage = () => {
  const { users, loading } = useUserData();
  const navigate = useNavigate();

  const handleRoleChange = async (userId, newRole) => {
    const userDocRef = doc(db, 'users', userId);
    const toastId = toast.loading('Updating role...');
    try {
      await updateDoc(userDocRef, { role: newRole });
      toast.success('User role updated successfully!', { id: toastId });
    } catch (error) {
      toast.error('Failed to update role.', { id: toastId });
      console.error("Role update error:", error);
    }
  };

  const handleDeleteUser = async (userToDelete) => {
    if (!window.confirm(`Are you sure you want to delete user ${userToDelete.clientName || userToDelete.email}? This will NOT delete their uploaded documents.`)) {
      return;
    }
    const toastId = toast.loading("Deleting user...");
    try {
      await deleteDoc(doc(db, 'users', userToDelete.id));
      toast.success("User deleted successfully.", { id: toastId });
    } catch (error) {
      toast.error("Failed to delete user.", { id: toastId });
      console.error("Delete user error:", error);
    }
  };

  if (loading) return <PageTitle>Loading Users...</PageTitle>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <PageTitle style={{ marginBottom: 0 }}>User Management</PageTitle>
        <Button onClick={() => navigate('/admin/add-user')} style={{ width: 'auto' }}>
          <Plus size={20} style={{ marginRight: '8px' }}/>
          Add User
        </Button>
      </div>

      <DocumentTable>
        <TableHead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Actions</th>
          </tr>
        </TableHead>
        <tbody>
          {users.map(user => (
            <TableRow key={user.id}>
              {/* UPDATED: Added data-label attributes for mobile view */}
              <TableCell data-label="Name">{user.clientName}</TableCell>
              <TableCell data-label="Email">{user.email}</TableCell>
              <TableCell data-label="Role">
                <RoleSelect
                  value={user.role}
                  onChange={(e) => handleRoleChange(user.id, e.target.value)}
                  disabled={user.id === auth.currentUser.id}
                >
                  <option value="client">Client</option>
                  <option value="data-entry">Data-Entry</option>
                  <option value="admin">Admin</option>
                </RoleSelect>
              </TableCell>
              <TableCell data-label="Actions">
                <ActionButton
                  className="reject"
                  onClick={() => handleDeleteUser(user)}
                  disabled={user.id === auth.currentUser.id}
                >
                  <Trash2 size={16} />
                </ActionButton>
              </TableCell>
            </TableRow>
          ))}
        </tbody>
      </DocumentTable>
    </div>
  );
};

export default ManageUsersPage;